import React, { useEffect, useState } from 'react';
import { IStudent } from './types';
import StudentCard from './StudentCard';

const StudentList = () => {
  const [students, setStudents] = useState<IStudent[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`/api-v2/student`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(r => {
        console.log(r);
        if (!r.ok) throw new Error(r.statusText);
        return r;
      })
      .then(r => r.text())
      .then(r => JSON.parse(r))
      .then(r => setStudents(r))
      .catch(e => setError(e));
  }, []);

  if (error) {
    if (String(error).indexOf('Unauthorized') > 0) {
      window.location.href = '/Identity/Account/Login?ReturnUrl=/student';
    }
    return (
      <div className='alert alert-danger'>
        <h1 className='alert-heading'>Error Occurred</h1>
        <p>{String(error)}</p>
      </div>
    );
  }

  return (
    <div className='row'>
      {students.map(student => (
        <StudentCard key={student.studentId} student={student} />
      ))}
    </div>
  );
};

export default StudentList;
